import {useEffect} from 'react'

export default function useDisablePageScroll(disable) {
  useEffect(() => {
    if (!disable) {
      document.documentElement.classList.remove('is-clipped')
    } else {
      document.documentElement.classList.add('is-clipped')
    }
    return () => document.documentElement.classList.remove('is-clipped')
  }, [disable])
}
